import axios, { AxiosInstance } from 'axios';

let publicAxios: AxiosInstance | undefined;

/**
 * The axios instance anonymous endpoints go through. `axios.create` inherits `axios.defaults`
 * (baseURL, timeout — see `constants/api`) but **not** `App`'s interceptors, which is the point: the
 * response interceptor turns any 401 into a forced Auth0 logout, and a caller with no session needs
 * to render its own error state instead of being redirected out of the page.
 *
 * Created on first use rather than at import: `constants/api` sets the defaults as a side effect of
 * `index.js`, so an instance built at module scope could capture an empty baseURL.
 */
export const getPublicAxios = (): AxiosInstance => {
  if (!publicAxios) {
    publicAxios = axios.create();
    // No session to speak of: never send the vendor's bearer token to a public endpoint.
    publicAxios.defaults.headers.common = {};
  }
  return publicAxios;
};
